var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "sign-in-container",
      style: `paddingTop:${_vm.barHeight}px`,
    },
    [
      _c("van-nav-bar", {
        staticClass: "van-bar",
        attrs: { title: "", "left-arrow": "" },
        on: { "click-left": _vm.closeWeb },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "left-nav",
                  attrs: {
                    src: require("@/assets/packageAssets/common/arrow02.png"),
                    alt: "back",
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", { staticClass: "rules", on: { click: _vm.goToRules } }, [
        _vm._v(_vm._s(_vm.$t("lang.call.tit1"))),
      ]),
      _c(
        "div",
        { staticClass: "sign-in-header" },
        [
          _c("span", [_vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.title1a")))]),
          _c("span", { staticClass: "dollar-amount" }, [
            _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.title1b"))),
          ]),
          _vm.$i18n.locale === "id" ? [_c("br")] : _vm._e(),
          _c("span", [_vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.title1c")))]),
        ],
        2
      ),
      _c("div", { staticClass: "sign-in-wrapper" }, [
        _c("div", { staticClass: "sign-in-box" }, [
          _c("div", { staticClass: "header-wrapper" }, [
            _c("div", { staticClass: "left" }, [
              _c("div", { staticClass: "total" }, [
                _vm._v(_vm._s(_vm.$t("lang.dl.total"))),
              ]),
              _c("div", { staticClass: "coin-wrapper" }, [
                _c("span", [_vm._v(_vm._s(_vm.beansAmount))]),
                _c("img", {
                  attrs: {
                    src: _vm.getMatchImg("beans"),
                    alt: "coin",
                    width: "24",
                    height: "24",
                  },
                }),
                _c("span", [
                  _vm._v(
                    "≈ " +
                      _vm._s(
                        `${_vm.currencyCode} ${_vm.handleCentsToDollars(
                          _vm.currencyAmount
                        )}`
                      )
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "right" }, [
              _c("div", { staticClass: "date" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/clock.png"),
                    alt: "coin",
                    width: "16",
                    height: "16",
                  },
                }),
                _c("span", [_vm._v(_vm._s(_vm.handleFormatCountdown))]),
              ]),
              _c(
                "div",
                { staticClass: "withdraw", on: { click: _vm.goToWithdrawal } },
                [
                  _vm.$i18n.locale == "pt"
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/withdraw-pt.png"),
                          alt: "image",
                          width: "20",
                          height: "20",
                        },
                      })
                    : _c("img", {
                        attrs: {
                          src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/withdraw.png"),
                          alt: "image",
                          width: "16",
                          height: "16",
                        },
                      }),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.withdraw"))),
                  ]),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "gift-wrapper" }, [
            _c("div", { staticClass: "gift-title" }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava//star.png"),
                  alt: "star",
                  width: "24",
                  height: "24",
                },
              }),
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.subTitle"))),
              ]),
              _c("img", {
                attrs: {
                  src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/star.png"),
                  alt: "star",
                  width: "24",
                  height: "24",
                },
              }),
            ]),
            _c(
              "div",
              { staticClass: "gift-card" },
              [
                !_vm.listLoading
                  ? [
                      _vm._l(_vm.rewardsList, function (item) {
                        return [
                          _c(
                            "div",
                            { key: item.day, staticClass: "card-wrapper" },
                            [
                              _c(
                                "div",
                                {
                                  class: [
                                    "card",
                                    item.ifCurDay ? "now-card" : "disable-card",
                                  ],
                                },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v(
                                      _vm._s(
                                        `${_vm.$t(
                                          "lang.sevenKeepSignin.day"
                                        )} ${item.index}`
                                      )
                                    ),
                                  ]),
                                  _c("div", { staticClass: "content" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          ((item.rewardDataList || [])[0] || {})
                                            .rewardPropNumber || "-"
                                        )
                                      ),
                                    ]),
                                    _c("img", {
                                      attrs: {
                                        src: _vm.getMatchImg("beans"),
                                        alt: "image",
                                        width: "20",
                                        height: "20",
                                      },
                                    }),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "badge" },
                                [
                                  item.ifSigned
                                    ? [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/on-check.png"),
                                            width: "22",
                                            height: "22",
                                            alt: "image",
                                          },
                                        }),
                                      ]
                                    : item.index <= _vm.currentDay
                                    ? [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/off-check.png"),
                                            width: "22",
                                            height: "22",
                                            alt: "image",
                                          },
                                        }),
                                      ]
                                    : void 0,
                                ],
                                2
                              ),
                            ]
                          ),
                        ]
                      }),
                      _vm.rewardsList.length > 0
                        ? _c("div", { staticClass: "card-wrapper" }, [
                            _c("div", { class: ["card", "final-card"] }, [
                              _vm._m(0),
                              _c("div", { staticClass: "content" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      (
                                        (_vm.fullSignRewardConfig
                                          .rewardDataList || [])[0] || {}
                                      ).rewardPropNumber || "-"
                                    )
                                  ),
                                ]),
                                _c("img", {
                                  attrs: {
                                    src: _vm.getMatchImg("beans"),
                                    alt: "image",
                                    width: "20",
                                    height: "20",
                                  },
                                }),
                              ]),
                            ]),
                            _c("div", { staticClass: "badge" }, [
                              !_vm.ifFullSign
                                ? _c("img", {
                                    attrs: {
                                      src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/lock.png"),
                                      width: "20",
                                      height: "20",
                                      alt: "image",
                                    },
                                  })
                                : _c("img", {
                                    attrs: {
                                      src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/on-check.png"),
                                      width: "20",
                                      height: "20",
                                      alt: "image",
                                    },
                                  }),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  : [
                      _c(
                        "div",
                        { staticClass: "loading-wrapper" },
                        [_c("van-loading")],
                        1
                      ),
                    ],
              ],
              2
            ),
            _c("div", { staticClass: "tips" }, [
              _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.title1"))),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "more-title" }, [
        _c("div", { staticClass: "gift-title" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava//star.png"),
              alt: "star",
              width: "24",
              height: "24",
            },
          }),
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.earnMore"))),
          ]),
          _c("img", {
            attrs: {
              src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/star.png"),
              alt: "star",
              width: "24",
              height: "24",
            },
          }),
        ]),
        _c("div", { staticClass: "tips" }, [
          _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.title2"))),
        ]),
      ]),
      _c("div", { staticClass: "more-wrapper" }, [
        _c("div", { staticClass: "item", on: { click: _vm.goToInvite } }, [
          _c("img", {
            attrs: {
              src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/inviting-friends.png"),
              alt: "image",
              width: "40",
              height: "40",
            },
          }),
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.more1"))),
          ]),
          _c("img", {
            attrs: {
              src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/arrow.png"),
              alt: "image",
              width: "30",
              height: "30",
            },
          }),
        ]),
        _c("div", { staticClass: "item", on: { click: _vm.goToDaily } }, [
          _c("img", {
            attrs: {
              src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/daily-task.png"),
              alt: "image",
              width: "40",
              height: "40",
            },
          }),
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.more2"))),
          ]),
          _c("img", {
            attrs: {
              src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/arrow.png"),
              alt: "image",
              width: "30",
              height: "30",
            },
          }),
        ]),
        _c("div", { staticClass: "item", on: { click: _vm.goToCall } }, [
          _c("img", {
            attrs: {
              src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/match-call.png"),
              alt: "image",
              width: "40",
              height: "40",
            },
          }),
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.more3"))),
          ]),
          _c("img", {
            attrs: {
              src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/arrow.png"),
              alt: "image",
              width: "30",
              height: "30",
            },
          }),
        ]),
        _c("div", { staticClass: "item", on: { click: _vm.goToChat } }, [
          _c("img", {
            attrs: {
              src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/chat.png"),
              alt: "image",
              width: "40",
              height: "40",
            },
          }),
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.more4"))),
          ]),
          _c("img", {
            attrs: {
              src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/arrow.png"),
              alt: "image",
              width: "30",
              height: "30",
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "footer" }, [
        _c("div", { staticClass: "whatapp", on: { click: _vm.goToWhatapp } }, [
          _c("img", {
            attrs: {
              src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/whatapp.png"),
              alt: "coin",
              width: "24",
              height: "24",
            },
          }),
          _c("span", [_vm._v("WhatApp")]),
        ]),
        _c("div", { staticClass: "whatapp-text" }, [
          _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.whatapp"))),
        ]),
      ]),
      _c(
        "van-dialog",
        {
          attrs: {
            title: "",
            showConfirmButton: false,
            showCancelButton: false,
            className: "van-dia-class",
          },
          model: {
            value: _vm.popupVisible,
            callback: function ($$v) {
              _vm.popupVisible = $$v
            },
            expression: "popupVisible",
          },
        },
        [
          _c("div", { staticClass: "dialog-wrapper" }, [
            _c("div", { staticClass: "header" }, [
              _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.subTitle"))),
            ]),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "amount" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.rewardsInfo.rewardBeanNum || "-")),
                ]),
                _c("img", {
                  attrs: {
                    src: _vm.getMatchImg("beans"),
                    alt: "coin",
                    width: "48",
                    height: "48",
                  },
                }),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "button", on: { click: _vm.handleClosePopup } },
              [_vm._v("OK")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "final-image" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/packageAssets/views/P2_Page/SevenKeepSignin/vava/treasure-box.png"),
          alt: "image",
          width: "36",
          height: "23",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }